<template>
  <div class="container spacing-top-50">
    <div class="columns">
      <div class="column">
        <div class="columns table-padding-fix">
          <div class="column is-4">
            <b-field label="Filteren">
                <b-input v-model="search"></b-input>
            </b-field>
          </div>
          <div class="column">
            <div class="spacing-top">
              <a class="button is-primary" :class="{ 'is-loading': isSyncing }" v-on:click="sync">Crediteuren synchroniseren</a>
            </div>
          </div>
        </div>

        <section class="spacing-top">
          <b-table
            :data="filteredList"
            :paginated="true"
            :pagination-simple="false"
            :per-page="15"
            default-sort-direction="'asc'"
            default-sort="subNr">
            <template slot-scope="crediteur">
              <b-table-column field="subNr" width="100" label="Nr." sortable numeric>
                {{ crediteur.row.subNr }}
              </b-table-column>
              <b-table-column field="acctName" label="Naam" sortable>
                {{ crediteur.row.acctName }}
              </b-table-column>
              <b-table-column field="addrLine1" label="Adres" sortable>
                {{ crediteur.row.addrLine1 }}
              </b-table-column>
              <b-table-column field="city" label="Stad" sortable>
                {{ crediteur.row.city }}
              </b-table-column>
              <b-table-column field="country" label="Land" sortable>
                {{ crediteur.row.country }}
              </b-table-column>
              <b-table-column field="postCode" label="Post code" sortable>
                {{ crediteur.row.postCode }}
              </b-table-column>
              <b-table-column field="vatNr" label="BTW nummer" sortable>
                {{ crediteur.row.vatNr }}
              </b-table-column>
              <b-table-column field="vatCode" label="BTW code" sortable>
                {{ crediteur.row.vatCode }}
              </b-table-column>
              <b-table-column field="email" label="Email" sortable>
                <a :href="`mailto:${crediteur.row.email}`">{{ crediteur.row.email }}</a>
              </b-table-column>
            </template>
          </b-table>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'crediteuren'
    ]),
    filteredList () {
      const searchQuery = this.search.toLowerCase().split('/')

      if (searchQuery.length <= 0) {
        return this.crediteuren
      }

      return this.crediteuren.filter(crediteur => {
        for (let search of searchQuery) {
          for (var key in crediteur) {
            const value = String(crediteur[key]).toLowerCase()

            if (value.includes(search)) {
              return true
            }
          }
        }

        return false
      })
    }
  },
  data () {
    return {
      isSyncing: false,
      search: ''
    }
  },
  created () {
    this.$store.dispatch('getCrediteuren', true).catch(() => {
      this.$snackbar.open({
        type: 'is-danger',
        message: 'Er ging iets fout tijdens het ophalen van de crediteuren.'
      })
    })
  },
  methods: {
    async sync () {
      this.isSyncing = true

      await this.$store.dispatch('syncCrediteuren').catch(() => {
        this.$snackbar.open({
          type: 'is-danger',
          message: 'Er ging iets fout tijdens het synchroniseren van de crediteuren.'
        })
      })

      this.isSyncing = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/crediteuren.vue